import awaitWrap from './await-wrap';
import notifyCaughtError from './notify-caught-error';
import notifySuccess from './notify-success';

export default ({ $vs = undefined, action, success, onSuccess, on422, onError }) => async (...params) => {
  $vs && $vs.loading();
  let response = undefined;

  try {
    response = await awaitWrap(action)(...params);
    $vs && success && notifySuccess({
      $vs,
      ...success,
    });
    onSuccess && await awaitWrap(onSuccess)(response.data);
  } catch (error) {
    if (422 === error?.response?.status && on422) {
      await awaitWrap(on422)(error.response.data);
    } else if (onError) {
      await awaitWrap(onError)(error);
    } else {
      $vs && notifyCaughtError({ $vs, error });
    }
  }

  $vs && $vs.loading.close();

  return response?.data;
};
